import { FC, useState } from 'react';
import { IDish } from '../../../types/dishes.types';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { COLORS, FONTS } from '../../../constants';
import { Button } from '../../../components/Button';
import { convertPrice } from '../../../services/utils';
import RenderHTML from 'react-native-render-html';
import { STYLE_VARS } from '../../../constants/style-vars';

interface ExtraDishItemProps {
  item: IDish;
  onAddToCart?: (item: IDish, type: number, quantity: number) => void;
  type: number;
  maxQuantity?: number;
}

const ExtraDishItem: FC<ExtraDishItemProps> = ({
  item,
  onAddToCart,
  type,
  maxQuantity = 100,
}) => {
  const [quantity, setQuantity] = useState<number>(1);

  const handleAdd = () => {
    if (quantity < maxQuantity) {
      setQuantity((prevQuantiy) => prevQuantiy + 1);
    }
  };

  const handleMinus = () => {
    if (quantity > 1) {
      setQuantity((prevQuantiy) => prevQuantiy - 1);
    }
  };

  return (
    <View
      style={{
        width: '100%',
      }}
      key={item.id}
    >
      <TouchableOpacity
        style={{
          marginBottom: 7,
        }}
        onPress={() => {
          if (onAddToCart) {
            onAddToCart(item, type, quantity);
          }
        }}
      >
        <Image
          source={
            item.image
              ? {
                  uri: item.image,
                }
              : require('../../../assets/dish-image.png')
          }
          style={[
            {
              width: '100%',
              borderRadius: 18,
              height: 170,
            },
          ]}
        />
      </TouchableOpacity>
      <Text
        style={{
          fontFamily: FONTS.AvenirHeavy,
          fontWeight: '800',
          fontSize: 19,
          color: COLORS.BLACK,
          marginBottom: 8,
        }}
      >
        {item.name}
      </Text>
      <View
        style={{
          width: 60,
          height: 2,
          marginBottom: 8,
          backgroundColor: COLORS.RED_PRIMARY,
        }}
      />
      <View style={{ marginBottom: 10 }}>
        <RenderHTML
          source={{ html: item.description }}
          tagsStyles={{
            body: {
              fontFamily: FONTS.AvenirMedium,
              fontSize: 16,
              fontWeight: '500',
              color: COLORS.GREY,
            },
          }}
        />
      </View>
      <Text
        style={{
          fontFamily: FONTS.AvenirMedium,
          fontWeight: '800',
          fontSize: 19,
          color: COLORS.RED_PRIMARY,
          marginBottom: 8,
        }}
      >
        {`HKD ${convertPrice(item.price)}`}
      </Text>
      <View style={{ marginBottom: 5 }}>
        <Text
          style={{
            fontFamily: FONTS.AvenirMedium,
            fontSize: 14,
            fontWeight: '500',
            color: COLORS.GREY,
          }}
        >
          {'Number Of Meals:'}
        </Text>
      </View>
      <View style={styles.countContainer}>
        <TouchableOpacity onPress={handleMinus} activeOpacity={1}>
          <Image
            style={styles.countBtnIcon}
            source={require('../../../assets/minus-red-icon.png')}
          />
        </TouchableOpacity>
        <Text
          style={{
            ...styles.countNumber,
            paddingHorizontal: 10,
          }}
        >
          {quantity}
        </Text>
        <TouchableOpacity activeOpacity={1} onPress={handleAdd}>
          <Image
            style={styles.countBtnIcon}
            source={require('../../../assets/add-icon.png')}
          />
        </TouchableOpacity>
      </View>
      <View
        style={{
          flexDirection: 'row',
        }}
      >
        <Button
          style={{
            paddingHorizontal: 20,
            paddingVertical: 10,
            backgroundColor: COLORS.RED_PRIMARY,
            borderRadius: 16,
          }}
          className=""
          text="Add to Cart"
          arrowRight={false}
          textStyle={{
            fontFamily: FONTS.AvenirMedium,
            fontWeight: '500',
            fontSize: 16,
            color: COLORS.WHITE,
          }}
          onPress={() => {
            if (onAddToCart) {
              onAddToCart(item, type, quantity);
            }
          }}
        />
      </View>
    </View>
  );
};

export default ExtraDishItem;

const styles = StyleSheet.create({
  countContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  countBtn: {},
  countBtnIcon: {
    width: 20,
    height: 20,
  },
  countNumber: {
    fontSize: 12,
    color: COLORS.BLACK,
    fontFamily: STYLE_VARS.avenirMediumFont,
  },
});
